import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../../shared/index';

import { FormElementHbaProfileData } from '../../shared/model/vertical/hba/form-element-hba-profile-data.model';

@Component({
  selector: 'wl-form-builder-hba-profile-data-display-element',
  templateUrl: 'form-builder-hba-profile-data-display-element.component.html',
    standalone: false
})
export class FormBuilderHbaProfileDataDisplayElementComponent {
  @Input('hbaProfileDataSettings') hbaProfileDataSettings: FormElementHbaProfileData;
  private _translationService: TranslationService;

  public constructor(translationService: TranslationService) {
    this._translationService = translationService;
    this.hbaProfileDataSettings = new FormElementHbaProfileData();
  }

  ngOnInit(): void {}
}
